<template>
  <div>
    <div v-if="loading" class="text-xs-center"></div>
    <div
      v-else-if="!data"
      class="text-xs-center pa-2 grey lighten-4"
      style="border-radius: 10px; position: relative"
    >
      <div style="text-align: right">
        <v-btn icon color="primary" small style="margin: 0" @click="handleRefresh">
          <v-icon small>refresh</v-icon>
        </v-btn>
      </div>
      <v-icon x-large>highlight_off</v-icon>
      <div class="caption">Not found video</div>
    </div>
    <template v-else>
      <slot v-bind="{ url: url }"> </slot>
    </template>
  </div>
</template>

<script>
import config from '@/config'
import logsApi from '@/api/logs'
export default {
  props: ['value', 'pageid', 'video_url'],
  data() {
    return {
      loading: true,
      data: null,
      binary: null,
      url: ''
    }
  },
  async mounted() {
    this.handleRefresh()
  },
  methods: {
    handleRefresh() {
      this.loading = true
      try {
        this.data = JSON.parse(this.value)

        this.url = `${config.serverUrl}linemessagecontenttypefile?pageid=${this.pageid}&messageid=${this.data.id}`
      } catch (error) {
        if (this.video_url) {
          this.url = this.video_url
        }
        logsApi.postLogs({ error })
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/LineContentVideo.vue